/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestion_2Inputs */

const en_chat_suggestion_2 = /** @type {(inputs: Chat_Suggestion_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What grows well outdoors in the rainy season?`)
};

const th_chat_suggestion_2 = /** @type {(inputs: Chat_Suggestion_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกกลางแจ้งหน้าฝนควรใช้สายพันธุ์ไหน`)
};

const ja_chat_suggestion_2 = /** @type {(inputs: Chat_Suggestion_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What grows well outdoors in the rainy season?`)
};

const fr_chat_suggestion_2 = /** @type {(inputs: Chat_Suggestion_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What grows well outdoors in the rainy season?`)
};

const es_chat_suggestion_2 = /** @type {(inputs: Chat_Suggestion_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What grows well outdoors in the rainy season?`)
};

const ru_chat_suggestion_2 = /** @type {(inputs: Chat_Suggestion_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What grows well outdoors in the rainy season?`)
};

const zh_chat_suggestion_2 = /** @type {(inputs: Chat_Suggestion_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What grows well outdoors in the rainy season?`)
};

const vi_chat_suggestion_2 = /** @type {(inputs: Chat_Suggestion_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trồng ngoài trời mùa mưa thì giống nào tốt?`)
};

/**
* | output |
* | --- |
* | "What grows well outdoors in the rainy season?" |
*
* @param {Chat_Suggestion_2Inputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_suggestion_2 = /** @type {((inputs?: Chat_Suggestion_2Inputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestion_2Inputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_suggestion_2(inputs)
	if (locale === "ja") return ja_chat_suggestion_2(inputs)
	if (locale === "fr") return fr_chat_suggestion_2(inputs)
	if (locale === "es") return es_chat_suggestion_2(inputs)
	if (locale === "ru") return ru_chat_suggestion_2(inputs)
	if (locale === "zh") return zh_chat_suggestion_2(inputs)
	if (locale === "vi") return vi_chat_suggestion_2(inputs)
	return en_chat_suggestion_2(inputs)
});